import { useMemo } from 'react'
import { useChatController } from '../hooks/useChatController'
import type { ChatProviderProps } from '../types/chat'
import { ChatContext } from './chatContext'

export function ChatProvider({
  authenticatedFetch,
  children,
  config,
}: ChatProviderProps) {
  const controller = useChatController({ authenticatedFetch, config })
  const value = useMemo(
    () => ({
      state: controller.state,
      actions: controller.actions,
      meta: { authenticatedFetch, config },
    }),
    // useChatController returns a fresh object literal every render, so depending on
    // `controller` itself would defeat the memo and re-render every useChat() consumer.
    [authenticatedFetch, config, controller.actions, controller.state],
  )

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
}
